"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LangfuseNotFoundError = void 0;
const BaseError_1 = require("./BaseError");
class LangfuseNotFoundError extends BaseError_1.BaseError {
    constructor(description = "Not Found") {
        super("LangfuseNotFoundError", 404, description, true);
    }
}
exports.LangfuseNotFoundError = LangfuseNotFoundError;
